export default {
  /**接口请求的基础路径 */
  baseUrl: {
    dev: '/dev-api',
    pro: '/prod-api', // 生产路径
  },
  loginUrl: '/'
};